enum Locale {
  EnUs = 'en-us',
}

export default Locale;
